<div class="toggle-wrapper">
  <h4>
    <strong class="semi-bold"> Is the site wheelchair accessible? </strong>
  </h4>
  <curbnturf-toggle [selected]="selected('wheelchair')" (clicked)="toggleWheelchair()"></curbnturf-toggle>
</div>
<div *ngIf="selected('wheelchair')" [formGroup]="amenities">
  <textarea
    [formControl]="description('wheelchair')"
    placeholder="What makes this location wheelchair accessible?&#10;(e.g. The ground is level and solidly packed.)"
  ></textarea>
</div>
